export default __webpack_public_path__ + "static/media/fuel-card-active.b17f387b.svg";